import React from 'react';
import './styles.scss';
interface UnderlineProps {
    disabled?: boolean | 'inputOnly';
}

export function Underline(props: UnderlineProps) {
    return (
        <>
            <div className={'tsr-input-underline'} style={props.disabled ? { opacity: 0.65 } : { opacity: 1 }} />
            <div className={'tsr-input-underline-animation'} />
        </>
    );
}
